export const IMPRESSION_ACTIONS = {
    CONFIRM_TABLE_BOOKING: "impression-confirm-table-booking",
    CASH_BACK_EARNED: "cash-back-earned",
    CASH_BACK_TOGGLE: "cashback-toggle",
    BILL_DETAILS: "impression-bill-details",
    ONE_PURCHASE: "impression-one-purchase",
    IMPRESSION_REWARD_OFFERS: "impression-reward-offers",
    IMPRESSION_OFFERS: "impression-offers",
    IMPRESSION_PAYMENT_BANNER: "impression-payment-banner",
    IMPRESSION_CASH_BACK_BENEFIT_CALLOUT: "cashback-benefit-callout",
    IMPRESSION_TURBO_CHECKOUT: "impression-turbo-checkout",
    // Remove coupon
    IMPRESSION_REMOVE_COUPON: "impression-remove-coupon",
    IMPRESSION_COUPON_OFFERS: "impression-coupon-offers",
    BOOKING_DETAILS: "booking-details",
    BUY_DEAL: "buy-deal",

    SCAN_QR_ERROR_PAGE: "scan-qr-error-page",
    IMPRESSION_DISCLAIMER_BANNER: "disclaimer-banner",
    IMPRESSION_BENEFIT_CALLOUT: "impression-benefit-callout",

    // Generic error half-card (ARD: error events). Intentionally screen-agnostic.
    ERROR_HALF_CARD: "impression-error-half-card",

    //cancellation policy widget
    IMPRESSION_CC_POLICY_CART: "impression-cc-policy-cart",

    // bill details section
    IMPRESSION_BILL_VIEW_CHEVRON: "impression-bill-view-chevron",
    IMPRESSION_COLLAPSIBLE_BILL_UPSELL: "impression-collapsible-bill-upsell",
    IMPRESSION_DELIVERY_FEE_LINE_ITEM: "impression-delivery-fee-line-item",
    IMPRESSION_TAXES_AND_CHARGES_POPUP: "taxes-and-charges-pop-up",
    IMPRESSION_DELIVERY_FEE_UN_COLLAPSED_LINE_ITEM: "impression-delivery-fee-un-collapsed-line-item",
    IMPRESSION_BILL_DETAILS_BANNER: "impression-bill-details-banner",
    IMPRESSION_BILL_DETAILS_BANNER_HALF_CARD: "impression-bill-details-banner-halfcard",

    // steal store cart screen
    IMPRESSION_STEAL_STORE_CART: "impression-steal-store-cart",
    IMPRESSION_ITEM: "impression-item",
    IMPRESSION_TURBO_PAY_BTN: "impression-turbo-pay-btn",

    // dine cash pooling screen
    IMPRESSION_DINECASH_POOLING_SCREEN: "impression-dinecash-pool-lp",
    IMPRESSION_DINECASH_QR_CODE: "impression-dinecash-pool-qr",
    IMPRESSION_DINECASH_WHATSAPP_SHARE: "impression-dinecash-pool-share",
    IMPRESSION_DINECASH_LEDGER: "impression-dinecash-pool-sender-details",
    IMPRESSION_DINECASH_DONE_CTA: "impression-dinecash-pool-cta",
    IMPRESSION_DINECASH_POOL_GRATIFICATION: "impression-dinecash-pool-gratification",
    IMPRESSION_DINECASH_POOL_WIDGET: "impression-poolcash-nudge",
};

export const CLICK_ACTIONS = {
    CONFIRM_TABLE_BOOKING: "confirm",
    VIEW_ONE_BENEFITS: "click-view-one-benefits",
    CLICK_COUPON_OFFERS: "click-coupon-offers",
    CLICK_MORE_DETAILS: "click-more-details",
    BOOKING_DETAILS: "booking-details",
    CASH_BACK_TOGGLE: "cash-back-toggle",
    // Remove coupon
    CLICK_REMOVE_COUPON: "click-remove-coupon",
    APPLY_COUPON: "apply-coupon",
    TERMS_AND_CONDITIONS: "tnc",

    SCAN_QR_ERROR_PAGE: "scan-qr-error-page",
    // Generic error half-card CTA click (ARD: error events)
    ERROR_HALF_CARD: "click-error-half-card",
    CLICK_TOR: "tor",
    CLICK_TURBO_CHECKOUT: "click-turbo-checkout",
    CLICK_TURBO_PAYMENT_CHANGE: "click-turbo-payment-change",

    // bill details
    CLICK_BILL_VIEW_CHEVRON: "click-bill-view-chevron",
    CLICK_BILL_DETAILS_BANNER: "click-bill-details-banner",
    CLICK_BILL_DETAILS_BANNER_HALF_CARD: "click-bill-details-banner-halfcard",

    CLICK_BACK_BTN: "click-back-btn",
    CLICK_ITEM: "click-item",
    CLICK_TICKET_ITEM_UPDATE: "click-item-update",
    CLICK_DELETE_TICKET_ITEM: "click-delete-item",

    // dine cash pooling screen
    CLICK_DINECASH_WHATSAPP_SHARE: "click-dinecash-pool-share",
    CLICK_DINECASH_DONE_CTA: "click-dinecash-pool-cta",
    CLICK_DINECASH_POOL_WIDGET: "click-poolcash-nudge",
};

export const IMPRESSION_LABELS = {
    GUEST_DETAILS_IMPRESSION: "guest-details-impression",
    DEAL_CONFIRMED_VIEW: "deal-confirmed-view",
    PAY_IMPRESSION: "pay-impression",
    BOOKING_CARD: "booking-card-view",
    SCAN_AGAIN_IMPRESSION: "scan-again-impression",
    BOTTOM_POPUP_SCAN_AGAIN_IMPRESSION: "bottom-popup-scan-again-impression",
    CASHBACK_BENEFIT_CALLOUT: "cashback-benefit-callout",
    CONFIRM_VIEW: "confirm-view",
};

export const CLICK_LABELS = {
    GUEST_DETAILS_CLICK: "guest-details-click",
    DELETE_GUEST: "delete-guest",
    PAY_CLICK: "pay-click",
    TOR_CLICK: "tor-click",
    TERMS_AND_CONDITIONS_CLICK: "tnc-click",
    CONFIRM_TABLE_BOOKING_CLICK: "confirm-click",
    BACK_CLICK: "back-click",
    SCAN_AGAIN_CLICK: "scan-again-click",
    BOTTOM_POPUP_SCAN_AGAIN_CLICK: "bottom-popup-scan-again-click",
    CONFIRM_CLICK: "confirm-click",
};

export const ACTIONS = {
    PAY_BTN: "pay-btn",
    PAYMENT_LOCATION_ALERT: "do-payment-location-alert",
    PAYMENT_CART: "DO-PaymentCart",
    PAYMENT_CART_ACTION: "PaymentCart",
    ADD_TIP: "add-tip",
    HELP: "help",
    GO_BACK: "go-back",
    REMOVE_COUPON: "remove-coupon",
    TIPPING_WIDGET: "tipping-widget",
    CLICK_TURBO_CHECKOUT: "click-turbo-checkout",
    CLICK_TURBO_PAYMENT_CHANGE: "click-turbo-payment-change",
};

export const ACTION_TYPE = {
    PAY_BTN_VIEW: "pay-btn-view",
    HELP_CLICK: "help-click",
    BACK_CLICK: "back-click",
    PAY_BTN_CLICK: "pay-btn-click",
    PAYMENT_LOCATION_ALERT_VIEWED: "do-payment-location-alert-viewed",
    COUPON_SAVINGS_POPUP: "coupon-savings-popup",
    REMOVE_COUPON_CLICK: "remove-coupon-click",
    ADD_TIP_CLICK: "add-tip-click",
    TIPPING_WIDGET_VIEW: "tipping-widget-view",
};

export const COUPON_FAILIURE = "coupon_apply_error";
export const COUPON_SUCCESS = "coupon_apply_success";
